import { FC, Suspense as ReactSuspense, SuspenseProps as ReactSuspenseProps } from 'react';
import { Outlet } from 'react-router-dom';
import Spinner from '../../../components/spinner/Spinner';

interface SuspenseProps extends Omit<ReactSuspenseProps, 'fallback'> {
  fallback?: ReactSuspenseProps['fallback'];
}

const Suspense: FC<SuspenseProps> = (props) => {
  const {
    fallback = <Spinner size="large" />,
  } = props;
  return <ReactSuspense fallback={fallback}><Outlet /></ReactSuspense>;
};

export default Suspense;
